import React from 'react';
const Interests = ()=>{
    return (
        <div  className="interests">
        <h1  className="interests--title">Interests</h1>
        <p  className="interests--paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer auctor sapien non urna consectetur, vitae varius turpis cursus. Morbi ac mauris ac nulla posuere lobortis. Curabitur malesuada elit et nisi efficitur, sit amet fermentum quam suscipit. Suspendisse pretium tellus vel purus condimentum, id rutrum metus tincidunt.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer auctor sapien non urna consectetur, vitae varius turpis cursus. Morbi ac mauris ac nulla posuere lobortis. Curabitur malesuada elit et nisi efficitur, sit amet fermentum quam suscipit. Suspendisse pretium tellus vel purus condimentum, id rutrum metus tincidunt.</p>
        </div>
        
    )
}

export default Interests;